<template>
  <v-container>
    <h2>Modules</h2>
    <app-base
      ref="crud"
      :source="getModules"
      :post="postModules"
      :tableHeader="headers"
      @edit="onEdit"
      @remove="onRemove"
    >
      <template v-slot:title>Create Module</template>
      <template v-slot:form>
        <v-text-field
          id="name"
          v-model="name"
          label="Name"
          outlined
          dense
          :rules="[(v) => !!v || 'Name required']"
        />
        <v-select
          id="level"
          v-model="level"
          :rules="[rules.required]"
          outlined
          dense
          label="Level"
          :items="levels"
          item-value="uuid"
        >
          <template v-slot:selection="data">{{ data.item.name }}</template>
          <template v-slot:item="data">{{ data.item.name }}</template>
        </v-select>
        <v-file-input
          accept="image/*"
          show-size
          id="image"
          v-model="image"
          dense
          outlined
          prepend-icon
          label="Image"
        />
      </template>
    </app-base>
    <app-confirm-dialog v-model="removeDialog" @yes="onYes" :loading="removeLoading" />
    <app-edit-name v-model="editDialog" :item="editedItem" :patch="patch" @itemUpdated="onUpdate" />
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import Base from "./Base.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import EditName from "./EditName.vue";
import { postModules, getModules, getLevels, removeModule, patchModule } from "@/api/api";
import removeMixin from "@/mixins/removeMixin";
import editNameMixin from "@/mixins/editNameMixin";

export default {
  components: {
    appBase: Base,
    appConfirmDialog: ConfirmDialog,
    appEditName: EditName,
  },
  mixins: [removeMixin, editNameMixin],
  data() {
    return {
      rules: {
        required: (v) => !!v || "Level Required",
      },
      levels: [],
      name: "",
      level: null,
      image: null,
      file: null,
      getModules,
      postModules,
      headers: [
        { text: "Module", value: "name", align: "left" },
        { text: "Created", value: "created_at", align: "right" },
        { text: "Level", value: "level_name", align: "right" },
        { text: "", value: "button", align: "right" },
        { text: "Remove", value: "remove", align: "center" },
      ],
      remover: removeModule,
      patch: patchModule,
    };
  },
  async created() {
    try {
      const response = await getLevels();
      if (response.status === 200) {
        this.levels = response.data;
      }
    } catch (error) {
      console.log("Error getting the modules", error);
    }
  },
};
</script>
